import { Record } from 'immutable';

const {
    LOGOUT_SUCCESS
} = require('../auth/authActions').constants;

const {
    GET_PROFILE_REQUEST,
    GET_PROFILE_SUCCESS,
    GET_PROFILE_FAILURE,

    PROFILE_UPDATE_REQUEST,
    PROFILE_UPDATE_SUCCESS,
    PROFILE_UPDATE_FAILURE,

    ADD_USERS_CSV_REQUEST,
    ADD_USERS_CSV_SUCCESS,
    ADD_USERS_CSV_FAILURE,

    INVITE_USERS_REQUEST,
    INVITE_USERS_SUCCESS,
    INVITE_USERS_FAILURE
} = require('./profileActions').constants;

const InitialState = Record({
    lastUpdated: null,
    error: null,
    isLoggedIn: false,
    isFetching: false,
    isVerified: true,
    id: null,
    profile: {},
    school: {},
    displayName: null,
    email: null,
    isProfileCompleted: true,
    isSchool: false,
    emailVerified: true
});

const initialState = new InitialState();

/**
 * ## profileReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function profileReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    /**
     * ### Request starts
     * set the form to fetching and clear any errors
     */
    case GET_PROFILE_REQUEST:
    case PROFILE_UPDATE_REQUEST:
    case ADD_USERS_CSV_REQUEST:
    case INVITE_USERS_REQUEST:
        return state.set('isFetching', true)
                .set('error', null);

    /**
     * ### Request ends successfully
     *
     * the fetching is done, set the UI fields and the originalProfile
     *
     * Validate the data to make sure it's all good and someone didn't
     * mung it up through some other mechanism
     */
    case GET_PROFILE_SUCCESS:
    case PROFILE_UPDATE_SUCCESS: {
        const { data } = payload;
        return state.set('isFetching', false)
                .set('error', null)
                .set('lastUpdated', Date.now())
                .set('profile', data.profile)
                .set('school', data.school)
                .set('displayName', data.username)
                .set('email', data.email)
                .set('id', data.id)
                .set('isVerified', data.isVerified)
                .set('isProfileCompleted', data.profile.is_completed === 1)
                .set('isSchool', data.isSchool)
                .set('emailVerified', data.status !== 'not-active')
                .set('isLoggedIn', true);
    }

    case ADD_USERS_CSV_SUCCESS:
    case INVITE_USERS_SUCCESS:
        return state.set('isFetching', false);

    /**
     * User logged out, so reset form fields and original profile.
     */
    case LOGOUT_SUCCESS:
        return state.set('error', null)
                .set('lastUpdated', null)
                .set('profile', {})
                .set('school', {})
                .set('displayName', null)
                .set('email', null)
                .set('id', null)
                .set('isVerified', true)
                .set('isLoggedIn', false);

    case GET_PROFILE_FAILURE:
    case PROFILE_UPDATE_FAILURE:
    case ADD_USERS_CSV_FAILURE:
    case INVITE_USERS_FAILURE:
        return state.set('isFetching', false)
                .set('error', payload);

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/core/profile/profileReducer.js
 **/